import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import React from "react";
import DownArrowIcon from "src/icons/portfolio/DownArrowIcon";
import { ChartConfig, ChartName, DefaultDate, SubMenuOption } from "./analyticsTypes";
import DropdownSubmenu from "./DropdownSubmenu";
import { DateText, DateTitleWrapper, DateWrapper } from "./styles/filter.styles";

interface DateSelectionProps {
  mode: "compact" | "normal" | "none";
  chartName: ChartName;
  chart: ChartConfig<any>;
  date: string;
  dateOptions?: SubMenuOption[];
  onClick: (chart: ChartName, newDate: DefaultDate) => void;
  onRemoveChart: () => void;
  onMenuOpenChange?: (open: boolean) => void;
}

const DateSelection = (props: DateSelectionProps) => {
  const { mode, chartName, chart, date, dateOptions, onClick, onRemoveChart, onMenuOpenChange } =
    props;

  const [period, setPeriod] = React.useState<string>(date);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  // function runs when user clicks on date selection component
  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    onMenuOpenChange?.(true);
  };

  // function runs when menu is closed
  const handleClose = (): void => {
    setAnchorEl(null);
    onMenuOpenChange?.(false);
  };

  // function runs when user selects date option
  const handleSelection = (selection: SubMenuOption): void => {
    setPeriod(selection.label);
    onClick(chartName, selection.value as DefaultDate);
    handleClose();
  };

  React.useEffect((): void => {
    if (dateOptions && !dateOptions.find((option): boolean => option.value === date)) return;

    switch (date) {
      case "1W":
        setPeriod("this week");
        break;
      case "1M":
        setPeriod("this month");
        break;
      case "1Y":
        setPeriod("this year");
        break;
      case "ALL":
        setPeriod("all time");
        break;
    }
  }, [date]);

  return (
    <>
      <DateWrapper id="DateSelection" onClick={handleClick}>
        {mode === "compact" ? (
          <MoreHorizIcon style={{ fontSize: "24px", color: "#CCC" }} />
        ) : mode === "normal" ? (
          <DateTitleWrapper>
            <DateText color="#bdbbbb">Show</DateText> by {period}
            <DownArrowIcon color="#bdbbbb" />
          </DateTitleWrapper>
        ) : (
          <></>
        )}
      </DateWrapper>

      <DropdownSubmenu
        id={chartName}
        anchorEl={anchorEl}
        open={open}
        chart={chart}
        options={dateOptions}
        selected={period}
        onClose={handleClose}
        onSelection={handleSelection}
        onRemove={onRemoveChart}
      />
    </>
  );
};

export default DateSelection;
